module.exports = __webpack_public_path__ + "static/a4-86691a6711fd3d7b69b9611109880d01.png";